function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent } from '../../../../../wdh-foundation/wdh';
var READ_MORE_LINK_SELECTOR = '.read-more';
var READ_LESS_LINK_SELECTOR = '.read-less';

/**
 * Adds read more functionality to plain rich texts.
 * Any text between read more and read less link is
 * hidden on load and shown when read more is clicked
 *
 * Example:
 * This is visible text
 * <a href="#" class="read-more">Read more</>
 * This is hidden text
 * <a href="#" class="read-less">Read less</>
 */
var ReadMoreRichText = /*#__PURE__*/function (_WDHComponent) {
  function ReadMoreRichText() {
    _classCallCheck(this, ReadMoreRichText);
    return _callSuper(this, ReadMoreRichText, arguments);
  }
  _inherits(ReadMoreRichText, _WDHComponent);
  return _createClass(ReadMoreRichText, [{
    key: "init",
    value: function init(component) {
      var _this = this;
      var readMoreLink = component.querySelector(READ_MORE_LINK_SELECTOR);
      var readLessLink = component.querySelector(READ_LESS_LINK_SELECTOR);
      if (!readMoreLink || !readLessLink) return;
      readMoreLink.addEventListener('click', function (event) {
        event.preventDefault();
        _this.showReadMore(component);
      });
      readLessLink.addEventListener('click', function (event) {
        event.preventDefault();
        _this.hideReadMore(component);
      });
      this.hideReadMore(component);
    }
  }, {
    key: "hideReadMore",
    value: function hideReadMore(component) {
      var readMoreLink = component.querySelector(READ_MORE_LINK_SELECTOR);
      var readMoreTexts = this.getNextSiblings(readMoreLink);
      readMoreTexts.forEach(function (element) {
        if (element.style) element.style.display = 'none';
      });
      readMoreLink.style.display = '';
    }
  }, {
    key: "showReadMore",
    value: function showReadMore(component) {
      var readMoreLink = component.querySelector(READ_MORE_LINK_SELECTOR);
      var readMoreTexts = this.getNextSiblings(readMoreLink);
      readMoreTexts.forEach(function (element) {
        if (element.style) element.style.display = '';
      });
      readMoreLink.style.display = 'none';
    }
  }, {
    key: "getNextSiblings",
    value: function getNextSiblings(el) {
      var siblings = [];
      do {
        el = el.nextSibling;
        if (el) siblings.push(el);
      } while (el);
      return siblings;
    }
  }]);
}(WDHComponent);
new ReadMoreRichText('rich-text').run();